import { VarKey } from '../../Variables/Generated/VarKey.Data'
import { CoreType } from '../../Core/Core.Interfaces'
import { GenericTableSchemaInterface } from '../../Table/Table.Interfaces'

export const PersonaCollect00Table: GenericTableSchemaInterface = {
  id: 'persona-collect-00',
  name: 'Persona Collect 00',
  description: 'This table contains data regarding the persona collect funnel.',
  core: CoreType.STORAGE,
  // bot:"all",
  mapping: {
    c01: {
      name: 'Operator Name',
      variable: VarKey.OrgName
    },
    c02: {
      name: 'Facility ID',
      variable: VarKey.LocationFMSId
    },
    c03: {
      name: 'Journey Start'
    },
    c04: {
      name: 'Funnel',
      variable: VarKey.UserProfileCollectHolder
    },
    c05: {
      name: 'Funnel Start'
    },
    c06: {
      name: 'Persona Uknown'
    },
    c07: {
      name: 'Persona Collected'
    },
    c08: {
      name: 'Persona Known'
    }
  }
}
